export function formatRelativeDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return "";
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diffDays = Math.floor((startOfToday - startOfDate) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return d.toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "2-digit" });
  }
  if (diffDays === 0) {
    return d.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" });
  }
  if (diffDays === 1) return "Ayer";
  if (diffDays < 7) return `Hace ${diffDays} días`;
  return d.toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "2-digit" });
}

export function formatTestimonialAuthor(author) {
  if (!author) return '';
  const parts = author.trim().split(/\s+/);
  if (parts.length === 0) return '';
  
  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  
  const first = capitalize(parts[0]);
  if (parts.length === 1) {
    return `— ${first}`;
  }
  
  const secondInitial = parts[1][0].toUpperCase();
  return `— ${first} ${secondInitial}.`;
}

export function formatTestimonialDate(date) {
  if (!date) return '';
  return new Date(date).toLocaleDateString('es-ES');
}

export function formatTestimonialSnippet(text, author) {
    const trimmed = text.length > 140 ? `${text.slice(0, 140).trim()}…` : text.trim();
    const authorShort = formatTestimonialAuthor(author);
    return { text: trimmed, authorShort };
}
